import { z } from 'zod'
import { nullSafeOptionalString } from '../shared/schema'

// BL-4216 — default Media ids pre-selected for each variant of a Dynamic
// Intro Video slide (Group/Solo, graded and ungraded). Stored in a single
// settings doc; any field may be empty to mean "no default for this variant".
export const schema = z.object({
  groupMediaId: nullSafeOptionalString(),
  soloMediaId: nullSafeOptionalString(),
  groupUngradedMediaId: nullSafeOptionalString(),
  soloUngradedMediaId: nullSafeOptionalString(),
})

export type FirestoreSettingsDynamicIntroVideoDefaults = z.infer<typeof schema>

export const empty: FirestoreSettingsDynamicIntroVideoDefaults = Object.freeze(
  schema.parse({
    groupMediaId: '',
    soloMediaId: '',
    groupUngradedMediaId: '',
    soloUngradedMediaId: '',
  })
)
